import { memo } from 'react';
import cn from 'classnames';
import { ClickableIcon, HStack, IconArrowDown, IconArrowRight } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import styles from './Expander.module.css';

export interface ExpanderProps extends TestProps {
    className?: string;
    isDisabled?: boolean;
    isOpen: boolean;
    onClick: () => void;
}

export const Expander = memo<ExpanderProps>(function Expander({
    'data-testid': dataTestId = 'Expander',
    className,
    isDisabled,
    isOpen,
    onClick,
}) {
    return (
        <HStack className={cn(styles.expander, className, { [styles.opened]: isOpen })} justifyContent="center">
            <ClickableIcon data-testid={`${dataTestId}.CollapseButton`} isDisabled={isDisabled} onClick={onClick}>
                {isOpen ? (
                    <IconArrowDown color="strict-black" role="supplementary" />
                ) : (
                    <IconArrowRight color="strict-black" role="supplementary" />
                )}
            </ClickableIcon>
        </HStack>
    );
});
